<template>
    <div class="p-3">
        <form-modal
            id="rol"
            placeholder-button="Inserir" 

            title-modal="ROL"

            :fields="colunas"
            :values="dados"

            ref="modalForm"

            read
            update
            remove

            controles

            

            @ok="salvar"
            @edit="editar"
            @remove="deletarForm"
            @cancel="fechar"
        >
            <template #modal>                
                <modal :form="form" ref="modal" />
            </template>

            <template #table>
                <div>
                        
                    <filtro ref="filtro" @buscar="buscar" @adicionar="adicionar" :btn="permissao.c"/>

                    <div class="table-responsive">
                        <b-table
                            @row-dblclicked="editar"
                            head-variant="dark"
                            :fields="colunas"
                            :items="dados"
                        >
                            <template #cell(actions)="data">
                                <div class="d-flex">
                                    <b-button v-if="permissao.u" @click="editar(data.item)" variant="flat-primary">
                                        <i class="fas fa-edit"></i>
                                    </b-button>
                                    <b-button v-if="permissao.d" @click="deletar(data.item)" variant="flat-danger">
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                </div>
                            </template>
                        </b-table>                          
                    </div>  
                </div>
            </template>
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import {FormMixin} from "@/common/mixins/FormMixin";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Modal from "./modal";
import Filtro from "../Filtro";
export default {
    mixins: [AlertasMixin, FormMixin],
    components: {
        FormModal,
        Modal,
        Filtro
    },
    props: {
        empresaId: {
            type: String,
            required: true
        },
    },
    data: () => ({
        form : {},
        colunas : [],
        dados : [],
        
        
    }),
    mounted(){
        //this.buscar();
    },
    methods : {
        montar : function(){
            this.$refs['filtro'].montar();   
            this.inicializarColunas();
            this.fechar();
        },
        adicionar : function(){
            this.$refs.modalForm.openModal();
        },
        inicializarColunas : function(){
            this.colunas = [
                {key : "ano", label : "Ano"},
                {key : "mes", label : "Mês", formatter : (valor) => {
                    return valor == "Marco" ? "Março" : valor;
                }},
                {key : "final", label : "Valor da ROL",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                },
                {key : "destinacaoProgramaPD", label : "1% da ROL",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                },
                {key : "fndct", label : "FNDCT",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                },
                {key : "pd", label : "P&D ANEEL",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                },
                {key : "mme", label : "MME",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                }
                
            ];

            if(this.empresaSelecionada.segmento == 'Distribuicao'){
                this.colunas.push(...[
                    {key : "pee", label : "PEE",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    {key : "cdepd", label : "CDE P&D",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    {key : "cdepee", label : "CDE PEE",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    {key : "procel", label : "PROCEL",
                        formatter :(value) => {
                            return helpers.formatarValor(value);
                        }
                    },
                    
                ])
            }else{
                this.colunas.push({key : "cde", label : "CDE",
                    formatter :(value) => {
                        return helpers.formatarValor(value);
                    }
                },);
            }

            this.colunas.push(
                { key: "aplicacaoNONECE", label: "Valor à investir (NO,NE,CE)",
                    formatter : (value) => helpers.formatarValor(value)            
                },
            );
            this.colunas.push({key : "actions", label : "Ações"},);
        },
        fechar : function(){
            this.$refs['filtro'].buscar();

            this.form = {
                ano: "",
                mes: "",
                receitas: [],
                deducoes: [],
                bruta : 0,
                intermediaria : 0,
                final : 0,

                destinacaoProgramaPD : 0,
                fndct : 0,
                mme : 0,
                pd : 0,
                cde : 0,
                cdepd : 0,
                cdepee : 0,
                pee : 0,
                procel : 0,
                editar : false,
            };

        },
        salvar : function(){
            let form = cloneDeep(this.form);
            if(!this.$refs.modal.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar?').then(confirmado => {
                if(confirmado){

                    form.receitas = form.receitas.map(el => {
                        el.valor = helpers.removerValor(el.valor);
                        return el;
                    });
                    form.deducoes = form.deducoes.map(el => {
                        el.valor = helpers.removerValor(el.valor);
                        return el;
                    });

                    form.bruta = helpers.removerValor(form.bruta);
                    form.intermediaria = helpers.removerValor(form.intermediaria);
                    form.final = helpers.removerValor(form.final);
                    form.destinacaoProgramaPD = helpers.removerValor(form.destinacaoProgramaPD);
                    form.fndct = helpers.removerValor(form.fndct);
                    form.mme = helpers.removerValor(form.mme);
                    form.pd = helpers.removerValor(form.pd);
                    form.cde = helpers.removerValor(form.cde);          
                    form.cdepd = helpers.removerValor(form.cdepd);
                    form.cdepee = helpers.removerValor(form.cdepee);
                    form.pee = helpers.removerValor(form.pee);
                    form.procel = helpers.removerValor(form.procel);

                    form.empresaId = this.empresaId;

                    form.mes = helpers.retornarMeses().find(mes => mes.value == form.mes).enum;


                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.salvarRol(form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            this.$refs.modalForm.closeModal();
                            this.$refs['filtro'].buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        deletarForm : function(){
            this.deletar(this.form);
        },
        deletar : function(item){
            this.confirmar('Aviso','Deseja realmente excluir?').then(confirmado => {
                if(confirmado){

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.deletarRol(item.id).then(() => {
                        this.alertaSucesso('Excluído com sucesso!').then(() => {
                            this.$refs['filtro'].buscar();
                            this.$refs.modalForm.closeModal();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao excluir");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        editar : function(item){
            if(!this.permissao.u)
                return;

            let form = cloneDeep(item);
            this.form = form;
            this.form.mes = helpers.retornarMeses().find(mes => mes.enum == this.form.mes).value;
            this.form.receitas.map(el => {
                el.valor = helpers.formatarValor(el.valor);
                return el;
            });
            this.form.deducoes.map(el => {
                el.valor = helpers.formatarValor(el.valor);
                return el;
            });

            this.form.bruta = helpers.formatarValor(this.form.bruta);
            this.form.intermediaria = helpers.formatarValor(this.form.intermediaria);
            this.form.final = helpers.formatarValor(this.form.final);
            this.form.destinacaoProgramaPD = helpers.formatarValor(this.form.destinacaoProgramaPD);
            this.form.fndct = helpers.formatarValor(this.form.fndct);
            this.form.mme = helpers.formatarValor(this.form.mme);
            this.form.pd = helpers.formatarValor(this.form.pd);
            this.form.cde = helpers.formatarValor(this.form.cde);          
            this.form.cdepd = helpers.formatarValor(this.form.cdepd);
            this.form.cdepee = helpers.formatarValor(this.form.cdepee);
            this.form.pee = helpers.formatarValor(this.form.pee);
            this.form.procel = helpers.formatarValor(this.form.procel);

            this.form.editar = false;

            this.$refs.modalForm.openModal();
        },

        buscar : function(filtro){
            this.$store.dispatch(START_LOADING);
            MovimentacaoFinanceiraService.listarRol(this.empresaId, filtro.ano, filtro.anoFim, filtro.mesInicio, filtro.mesFim).then(response => {
                this.dados = response.data.data;
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    computed : {
        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('MovimentacaoFinanceiraRol');
        }
    }
}
</script>
<style lang="">
    
</style>